import { InvoiceItem } from './index';
import { ProviderDetails } from '../index';
import { DatasourceFullSiteInfo } from '../sites';

class InvoiceItemDifference {
    [key: string]: Partial<InvoiceItem>;
}

export interface InvoiceItemData extends InvoiceItemDifference {
    master: Partial<InvoiceItemWithVariantDetail>;
}

export class InvoiceItemWithVariantDetail extends InvoiceItem {
    difference?: InvoiceItemData;

    providers: ProviderDetails[];

    sites?: DatasourceFullSiteInfo[];

    variants: InvoiceItem[] = [];
}
